import Navigation from "../Components/Navigation";

function Learn() {
    return (
        <div>
            <Navigation path="learn" />
            <div className="container">
                <h1>Learn</h1>
                <p>
                    Our learning module is not under active development, but the section provides some nice symmetry on the homepage so I'm not removing it.
                </p>
            </div>
            <div className="row learn" />
        </div>
    );
}

export default Learn;
